const getters = {
  getPPOBProducts: (state) => state.ppob_products,
  getPPOBProduct: (state) => state.ppob_product,
};

export default getters;